import { useEffect, useState } from "react";
import { BellRinging } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function subscribeToPush() {
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.key),
  });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
}

export const PushAlertButton = () => {
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const [enabled, setEnabled] = useState(supported && Notification.permission === "granted");

  useEffect(() => {
    if (supported && Notification.permission === "granted") {
      subscribeToPush().catch(() => {});
    }
  }, [supported]);

  if (!supported) return null;

  const enable = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") {
        toast.info("Notifications are blocked. Allow them in your browser settings.");
        return;
      }
      await subscribeToPush();
      setEnabled(true);
      toast.success("Phone alerts are on. You will be notified about every new task.");
    } catch (e) {
      toast.error("Could not turn on alerts. Install the app and try again.");
    }
  };

  if (enabled) return null;

  return (
    <Button data-testid="enable-push-button" variant="ghost" size="sm" className="w-full mt-1 text-xs justify-start px-2" onClick={enable}>
      <BellRinging size={14} className="mr-1.5" /> Enable Phone Alerts
    </Button>
  );
};
